import Tenant from '@/models/tenant/Tenant';
import Paciente from '../pacientes/Pacientes';

export default class Rotina {
    public id: number;

    public descricao: string;

    public tenantId: number;

    public pacienteId: number;

    public tenant: Tenant;

    public paciente: Paciente;

    constructor() {
      this.id = 0;
      this.descricao = '';
      this.tenantId = 0;
      this.pacienteId = 0;
      this.tenant = new Tenant();
      this.paciente = new Paciente();
    }
}
